import React from 'react';
import './../App.css';
import XP44Hull from './XP44Hull';
import { Route, Redirect, Switch  } from "react-router-dom";
import XP44BowSprit from './XP44BowSprit';
import XP44HullTreatment from './XP44HullTreatment';
import XP44Transom from './XP44Transom';
import XP44Deck from './XP44Deck';
import XP44Sprayhood from './XP44Sprayhood';
import XP44Wheel from './XP44Wheel';
import XP44Mast from './XP44Mast';
import XP44Interior from './XP44Interior';
import XP44Galley from './XP44Galley';
import XP44Fabric from './XP44Fabric';
import XP44OwnersCabin from './XP44OwnersCabin';
import XP44AftCabin from './XP44AftCabin';
import Logo from './XP44-logo.svg';
import XP44Summary from './XP44Summary';
import XP44BathingPlatform from './XP44BathingPlatform';

import hullColor11 from '../assets/hullColors/Hull colour -  pure white RAL 9010 & 3 x light grey RAL 7035 waterliness.jpg';
import hullColor12 from '../assets/hullColors/Hull colour -  pure white RAL 9010 & 3 x black grey RAL 702 waterlines.jpg';
import hullColor17 from '../assets/hullColors/Hull colour - pure white RAL 9010 & pastel blue RAL 5024 & 3 x  waterlines.jpg';
import hullColor14 from '../assets/hullColors/Hull colour - light grey RAL 7035 & 3 x pure white RAL 9010 waterlines.jpg';
import hullColor15 from '../assets/hullColors/Hull colour - black grey RAL 7021 & 3 x pure white RAL 9010 waterlines.jpg';
import hullColor16 from '../assets/hullColors/Hull colour - pastel blue RAL 9010 & 3 x pure white RAL 9010 waterlines.jpg';

import fabric1 from '../assets/fabrics/JustFleckless–01Nature.jpg';
import fabric2 from '../assets/fabrics/JustFleckless–05Camel.jpg';
import fabric3 from '../assets/fabrics/JustFleckless–10Navy.jpg';
import fabric4 from '../assets/fabrics/JustFleckless–403Bambus.jpg';
import fabric5 from '../assets/fabrics/JustFleckless–710MoonGrey.jpg';
import fabric6 from '../assets/fabrics/JustFleckless–750OliveGrey.jpg';
import fabric7 from '../assets/fabrics/AlsaceBlue.jpg';
import fabric8 from '../assets/fabrics/AlsaceIvory.jpg';
import fabric9 from '../assets/fabrics/AlsaceSand.jpg';
import fabric10 from '../assets/fabrics/Nubilux709Argent.jpg';

import galley1 from '../assets/galleyColors/camoan_white_corian.jpg';
import galley2 from '../assets/galleyColors/black_quartz_corian.jpg';

import veneer1 from '../assets/interiorColors/nordic_oak.jpg';
import veneer2 from '../assets/interiorColors/teak.jpg';

import laminate1 from '../assets/interiorColors/teak_without_koto.jpg';
import laminate2 from '../assets/interiorColors/walnut.jpg';
import laminate3 from '../assets/interiorColors/teak_with_koto.jpg';

import sprayhood1 from '../assets/sprayhoodColors/without.jpg';
import sprayhood2 from '../assets/sprayhoodColors/Dark grey.jpg';
import sprayhood3 from '../assets/sprayhoodColors/Taupe.jpg';
import sprayhood4 from '../assets/sprayhoodColors/Captains blue.jpg';
import sprayhood5 from '../assets/sprayhoodColors/Silver grey.jpg';

import ConfiguratorContainer from '../ConfiguratorContainer';
import { withTranslation } from 'react-i18next';

class XP44Container extends ConfiguratorContainer {
    constructor(props) {
        super(props);

        this.logo = Logo;
        this.logoLink = 'https://www.x-yachts.com/en/yachts/xp/xp-44/';

        this.HullColourOptions = [
            { value: 1, label: this.props.t('Pure White'), description: this.props.t('(RAL 9010) & 3 x Pastel Blue (RAL 5024) integrated Gelcoat Water Lines'), preview: hullColor17 },
            { value: 2, label: this.props.t('Pure White'), description: this.props.t('(RAL 9010) & 3 x Black Grey (RAL 7021) integrated Gelcoat Water Lines'), preview: hullColor12 },
            { value: 3, label: this.props.t('Pure White'), description: this.props.t('(RAL 9010) & 3 x Light Grey (RAL 7035) integrated Gelcoat Water Lines'), preview: hullColor11 },
            { value: 4, label: this.props.t('Pastel Blue'), description: this.props.t('(RAL5024) & 3x Pure White (RAL9010)'), preview: hullColor16 },
            { value: 6, label: this.props.t('Light Grey'), description: this.props.t('(RAL 7035) & 3 x Pure White (RAL 9010) integrated Gelcoat Water Lines'), preview: hullColor14 },
            { value: 5, label: this.props.t('Black Grey'), description: this.props.t('(RAL 7021) & 3 x Pure White (RAL 9010) integrated Gelcoat Water Lines'), preview: hullColor15 }
        ];

        this.BowSpritOptions = [
            { value: 1, label: this.props.t('Standard GRP cowl in hull colour') },
            { value: 3, label: this.props.t('Carbon fibre bowsprit in hull colour') },
            { value: 4, label: this.props.t('Carbon fibre bowsprit  clear coated') }
        ];

        this.HullTreatmentOptions = [
            { value: 1, label: this.props.t('White') },
            { value: 2, label: this.props.t('Black (optional)') },
            { value: 3, label: this.props.t('Copper (optional)') }
        ];

        this.DeckOptions = [
            { value: 1, label: this.props.t('Genuine teak with black caulkings') },
            { value: 2, label: this.props.t('Flexiteek with grey stripes') }
        ];

        this.AftCabinLayoutOptions = [
            { value: 1, label: this.props.t('Sea berths') },
            { value: 2, label: this.props.t('Shelf') }
        ];

        this.OwnersCabinLayoutOptions = [
            { value: 1, label: this.props.t('Freeboard shelves port & starboard') },
            { value: 2, label: this.props.t('Freeboard combined cupboard and shelve above the berth (port & starboard) replacing standard shelve.') }
        ];

        this.OwnerBerthOptions = [
            { value: 1, label: this.props.t('Standard') },
            { value: 2, label: this.props.t('Drawers under owner berth for better storage and easier access') }
        ];

        this.SprayhoodOptions = [
            { value: 1, label: this.props.t('Without'), thumbnail: sprayhood1 },
            { value: 2, label: this.props.t('Dark grey'), thumbnail: sprayhood2 },
            { value: 3, label: this.props.t('Taupe'), thumbnail: sprayhood3 },
            { value: 4, label: this.props.t('Captains blue'), thumbnail: sprayhood4 },
            { value: 5, label: this.props.t('Silver grey'), thumbnail: sprayhood5 }
        ];

        this.BoomCoverOptions = this.SprayhoodOptions;

        this.WheelOptions = [
            { value: 1, label: this.props.t('Standard Black GRP wheel') },
            { value: 2, label: this.props.t('Optional White GRP wheel') }
        ];

        this.MastAndBoomOptions = [
            { value: 1, label: this.props.t('Standard silver anodized aluminum') },
            { value: 2, label: this.props.t('Optional white carbon mast') },
            { value: 3, label: this.props.t('Optional black carbon mast') },
            { value: 4, label: this.props.t('Optional clear coated carbon mast') }
        ];

        this.BathingPlatformOptions = [
            { value: 1, label: this.props.t('Without bathing platform') },
            { value: 2, label: this.props.t('With bathing platform') }
        ];

        this.VeneerOptions = [
            { value: 1, label: this.props.t('Nordic oak (standard)'), thumbnail: veneer1 },
            { value: 2, label: this.props.t('Modern teak (optional)'), thumbnail: veneer2 }
        ];

        this.FloorboardOptions = [
            { value: 1, label: this.props.t('Teak laminate (standard)'), thumbnail: laminate1 },
            { value: 2, label: this.props.t('Walnut laminate (optional)'), thumbnail: laminate2 },
            { value: 3, label: this.props.t('Teak with inlay stripes / holly (optional)'), thumbnail: laminate3 }
        ];

        this.PedestalOptions = [
            { value: 1, label: this.props.t('Standard - Flush top') },
            { value: 2, label: this.props.t('Optional - Compass mount') },
            { value: 3, label: this.props.t('Optional - Small instrument mount')},
            { value: 4, label: this.props.t('Optional - Large instrument mount') }
        ];

        this.WorktopOptions = [
            { value: 1, label: this.props.t('Worktop in Camoan white Corian'), thumbnail: galley1 },
            { value: 2, label: this.props.t('Worktop in black quartz Corian'), thumbnail: galley2 }
        ];

        this.FabricOptions = [
            { value: 1, label: this.props.t('Just Fleckless – 01 Nature'), thumbnail: fabric1 },
            { value: 2, label: this.props.t('Just Fleckless – 05 Camel'), thumbnail: fabric2 },
            { value: 3, label: this.props.t('Just Fleckless – 10 Navy'), thumbnail: fabric3 },
            { value: 4, label: this.props.t('Just Fleckless – 403 Bambus'), thumbnail: fabric4 },
            { value: 5, label: this.props.t('Just Fleckless – 710 Moon Grey'), thumbnail: fabric5 },
            { value: 6, label: this.props.t('Just Fleckless – 750 Olive Grey'), thumbnail: fabric6 },
            { value: 7, label: this.props.t('Alsace Blue'), thumbnail: fabric7 },
            { value: 8, label: this.props.t('Alsace Ivory'), thumbnail: fabric8 },
            { value: 9, label: this.props.t('Alsace Sand'), thumbnail: fabric9 },
            { value: 10, label: this.props.t('Nubilux 709 Argent'), thumbnail: fabric10 }
        ];

        this.HandrailOptions = [
            { value: 1, label: this.props.t('No handrails') },
            { value: 2, label: this.props.t('Wooden laminated') },
            { value: 3, label: this.props.t('Stainless steel') }
        ];



        this.state = Object.assign(this.state, {
            boat: 'xp44',
            exterior: {
                HullColorways: this.HullColourOptions[0],
                BowSpirit: this.BowSpritOptions[0],
                HullTreatment: this.HullTreatmentOptions[0],
                Deck: this.DeckOptions[0],
                TeakOnSideDecks: { value: 1, label: 'false' },
                TeakOnCoachroof: { value: 1, label: 'false' },
                Sprayhood: this.SprayhoodOptions[0],
                Wheel: this.WheelOptions[0],
                MastAndBoom: this.MastAndBoomOptions[0],
                BoomCover: this.BoomCoverOptions[0],
                PedestalOptions: this.PedestalOptions[0],
                BathingPlatform: this.BathingPlatformOptions[0]
            },
            interior: {
                Veneer:  this.VeneerOptions[0],
                Floorboards: this.FloorboardOptions[0],
                FabricSaloon: this.FabricOptions[0],
                Worktop: this.WorktopOptions[0],
                FabricCabins: this.FabricOptions[0],
                OwnersCabinLayout: this.OwnersCabinLayoutOptions[1],
                OwnerBerth: this.OwnerBerthOptions[0],
                AftCabinLayout: this.AftCabinLayoutOptions[0],
                Handrails: this.HandrailOptions[0],
                PleatedBlinds: { value: 1, label: 'false' },
                Mast: this.MastAndBoomOptions[0]
            }
        });

        this.steps = [
            { name: this.props.t('Hull colourways'), url: '/xp44/hull' },
            { name: this.props.t('Bowsprit'), url: '/xp44/bowsprit' },
            { name: this.props.t('Hull treatment'), url: '/xp44/hulltreatment' },
            { name: this.props.t('Deck'), url: '/xp44/deck' },
            { name: this.props.t('Bathing platform'), url: '/xp44/bathingplatform' },
            { name: this.props.t('Boat name'), url: '/xp44/transom' },
            { name: this.props.t('Mast and boom'), url: '/xp44/mast' },
            { name: this.props.t('Wheels'), url: '/xp44/wheel' },
            { name: this.props.t('Sprayhood & Boom Cover'), url: '/xp44/sprayhood' },

            { name: this.props.t('Interior surfaces'), url: '/xp44/surfaces' },
            { name: this.props.t('Interior Fabric'), url: '/xp44/fabric' },
            { name: this.props.t('Galley'), url: '/xp44/galley' },
            { name: this.props.t('Owner\'s cabin'), url: '/xp44/ownerscabin' },
            { name: this.props.t('Aft cabins'), url: '/xp44/aftcabin' },
            
            { name: this.props.t('Summary'), url: '/xp44/summary' }
        ];

        this.handleHullConfigurationChange = this.handleHullConfigurationChange.bind(this);
    }

    handleHullConfigurationChange(newConfiguration) {
        let transom = this.state.transom;
        switch (newConfiguration.HullColorways.value) {
            case 1:
                transom.Name.color = this.colorOptions[0];
                transom.Port.color = this.colorOptions[0];
                break;
            case 2:
                transom.Name.color = this.colorOptions[3];
                transom.Port.color = this.colorOptions[3];
                break;
            case 3:
                transom.Name.color = this.colorOptions[2];
                transom.Port.color = this.colorOptions[2];
                break;
            case 4:
            case 5:
            case 6:
                transom.Name.color = this.colorOptions[1];
                transom.Port.color = this.colorOptions[1];
                break;
            default:
                break;

        }


        super.handleTransomChange(transom);
        super.handleExteriorConfigurationChange(newConfiguration);
    }

    handleExteriorConfigurationChange(newConfiguration) {
        let interior = this.state.interior;
        interior.Mast = newConfiguration.MastAndBoom;
        this.setState({ interior: interior });

        super.handleExteriorConfigurationChange(newConfiguration);
    }

    generateCode() {
        let data = [];
        data.push("xp44");

        data.push([]);
        let exterior = this.state.exterior;
        for (const key in exterior) {
            if (exterior.hasOwnProperty(key)) {
                let element = exterior[key].value;
                data[data.length - 1].push(element);
            }
        }

        data.push([]);
        data[data.length - 1].push([]);
        data[data.length - 1].push([]);

        let transom = this.state.transom;
        data[data.length - 1][0].push(transom.Name.value);
        data[data.length - 1][0].push(transom.Name.font.value);
        data[data.length - 1][0].push(transom.Name.size.value);
        data[data.length - 1][0].push(transom.Name.color.value);
        data[data.length - 1][0].push(transom.Name.horizontalOffset);
        data[data.length - 1][0].push(transom.Name.verticalOffset);

        data[data.length - 1][1].push(transom.Port.value);
        data[data.length - 1][1].push(transom.Port.font.value);
        data[data.length - 1][1].push(transom.Port.size.value);
        data[data.length - 1][1].push(transom.Port.color.value);
        data[data.length - 1][1].push(transom.Port.horizontalOffset);
        data[data.length - 1][1].push(transom.Port.verticalOffset);

        data.push([]);
        let interior = this.state.interior;
        for (const key in interior) {
            if (interior.hasOwnProperty(key)) {
                let element = interior[key].value;
                data[data.length - 1].push(element);
            }
        }
        
        var json = JSON.stringify(data);
        return btoa(json);
    }

    parseCode(code) {
        let json = JSON.parse(atob(code));

        if (json[0] !== 'xp44') {
            return;
        }

        let exterior = this.state.exterior;
        exterior.HullColorways = this.HullColourOptions.find(v => v.value === json[1][0]) || this.HullColourOptions[0];
        exterior.BowSpirit = this.BowSpritOptions.find(v => v.value === json[1][1]) || this.BowSpritOptions[0];
        exterior.HullTreatment = this.HullTreatmentOptions.find(v => v.value === json[1][2]) || this.HullTreatmentOptions[0];
        exterior.Deck = this.DeckOptions.find(v => v.value === json[1][3]) || this.DeckOptions[0];
        exterior.TeakOnSideDecks = { value: +json[1][4] || 1, label: '' };
        exterior.TeakOnCoachroof = { value: +json[1][5] || 1, label: '' };
        exterior.Sprayhood = this.SprayhoodOptions.find(v => v.value === json[1][6]) || this.SprayhoodOptions[0];
        exterior.Wheel = this.WheelOptions.find(v => v.value === json[1][7]) || this.WheelOptions[0];
        exterior.MastAndBoom = this.MastAndBoomOptions.find(v => v.value === json[1][8]) || this.MastAndBoomOptions[0];
        exterior.BoomCover = this.BoomCoverOptions.find(v => v.value === json[1][9]) || this.BoomCoverOptions[0];
        exterior.PedestalOptions = this.PedestalOptions.find(v => v.value === json[1][10]) || this.PedestalOptions[0];
        exterior.BathingPlatform = this.BathingPlatformOptions.find(v => v.value === json[1][11]) || this.BathingPlatformOptions[0];

        let transom = this.state.transom;
        transom.Name.value = json[2][0][0] || '';
        transom.Name.font = this.fontOptions.find(v => v.value === json[2][0][1]) || this.fontOptions[0];
        transom.Name.size = this.sizeOptions.find(v => v.value === json[2][0][2]) || this.sizeOptions[0];
        transom.Name.color = this.colorOptions.find(v => v.value === json[2][0][3]) || this.colorOptions[0];
        transom.Name.horizontalOffset = +json[2][0][4] || 1;
        transom.Name.verticalOffset = +json[2][0][5] || 1;

        transom.Port.value = json[2][1][0] || '';
        transom.Port.font = this.fontOptions.find(v => v.value === json[2][1][1]) || this.fontOptions[0];
        transom.Port.size = this.sizeOptions.find(v => v.value === json[2][1][2]) || this.sizeOptions[0];
        transom.Port.color = this.colorOptions.find(v => v.value === json[2][1][3]) || this.colorOptions[0];
        transom.Port.horizontalOffset = +json[2][1][4] || 1;
        transom.Port.verticalOffset = +json[2][1][5] || 1;
        
        let interior = this.state.interior;
        interior.Veneer = this.VeneerOptions.find(v => v.value === json[3][0]) || this.VeneerOptions[0];
        interior.Floorboards = this.FloorboardOptions.find(v => v.value === json[3][1]) || this.FloorboardOptions[0];
        interior.FabricSaloon = this.FabricOptions.find(v => v.value === json[3][2]) || this.FabricOptions[0];
        interior.Worktop = this.WorktopOptions.find(v => v.value === json[3][3]) || this.WorktopOptions[0];
        interior.FabricCabins = this.FabricOptions.find(v => v.value === json[3][4]) || this.FabricOptions[0];
        interior.OwnersCabinLayout = this.OwnersCabinLayoutOptions.find(v => v.value === json[3][5]) || this.OwnersCabinLayoutOptions[0];
        interior.OwnerBerth = this.OwnerBerthOptions.find(v => v.value === json[3][6]) || this.OwnerBerthOptions[0];
        interior.AftCabinLayout = this.AftCabinLayoutOptions.find(v => v.value === json[3][7]) || this.AftCabinLayoutOptions[0];
        interior.Handrails = this.HandrailOptions.find(v => v.value === json[3][8]) || this.HandrailOptions[0];
        interior.PleatedBlinds = { value: +json[3][9] || 1, label: '' };
        interior.Mast = exterior.MastAndBoom;

        
        this.setState(this.state);
    }

    renderSteps() {
        return (
            <Switch location={this.props.location}>
                <Route exact path="/xp44" render={() => <Redirect to="/xp44/hull" />} />

                <Route path="/xp44/hull" render={(props) => <XP44Hull {...props} onChange={this.handleHullConfigurationChange} onCodeSubmitted={this.parseCode} configuration={this.state.exterior} transom={this.state.transom} hullColourOptions={this.HullColourOptions} />} />
                <Route path="/xp44/bowsprit" render={(props) => <XP44BowSprit {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} bowSpritOptions={this.BowSpritOptions} />} />
                <Route path="/xp44/hulltreatment" render={(props) => <XP44HullTreatment {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} transom={this.state.transom} hullTreatmentOptions={this.HullTreatmentOptions} />} />
                <Route path="/xp44/transom" render={(props) => <XP44Transom {...props} onChange={this.handleTransomChange} configuration={this.state.exterior} transom={this.state.transom} fontOptions={this.fontOptions} sizeOptions={this.sizeOptions} colorOptions={this.colorOptions} />} />
                <Route path="/xp44/deck" render={(props) => <XP44Deck {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} transom={this.state.transom} deckOptions={this.DeckOptions} />} />
                <Route path="/xp44/bathingplatform" render={(props) => <XP44BathingPlatform {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} bathingPlatformOptions={this.BathingPlatformOptions} />} />
                <Route path="/xp44/sprayhood" render={(props) => <XP44Sprayhood {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} transom={this.state.transom} sprayhoodOptions={this.SprayhoodOptions} boomCoverOptions={this.BoomCoverOptions} />} />
                <Route path="/xp44/wheel" render={(props) => <XP44Wheel {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} wheelOptions={this.WheelOptions} pedestalOptions={this.PedestalOptions} />} />
                <Route path="/xp44/mast" render={(props) => <XP44Mast {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} transom={this.state.transom} mastAndBoomOptions={this.MastAndBoomOptions} />} />

                <Route path="/xp44/surfaces" render={(props) => <XP44Interior {...props} onChange={this.handleInteriorConfigurationChange} configuration={this.state.interior} veneerOptions={this.VeneerOptions} floorboardOptions={this.FloorboardOptions} />} />
                <Route path="/xp44/fabric" render={(props) => <XP44Fabric {...props} onChange={this.handleInteriorConfigurationChange} configuration={this.state.interior} fabricOptions={this.FabricOptions} handrailOptions={this.HandrailOptions} />} />
                <Route path="/xp44/galley" render={(props) => <XP44Galley {...props} onChange={this.handleInteriorConfigurationChange} configuration={this.state.interior} worktopOptions={this.WorktopOptions} />} />
                <Route path="/xp44/aftcabin" render={(props) => <XP44AftCabin {...props} onChange={this.handleInteriorConfigurationChange} configuration={this.state.interior} AftCabinLayout={this.AftCabinLayoutOptions} />} />
                <Route path="/xp44/ownerscabin" render={(props) => <XP44OwnersCabin {...props} onChange={this.handleInteriorConfigurationChange} fabricOptions={this.FabricOptions} ownersCabinLayoutOptions={this.OwnersCabinLayoutOptions} ownerBerthOptions={this.OwnerBerthOptions} configuration={this.state.interior} />} />

                <Route path="/xp44/summary" render={(props) => <XP44Summary {...props} country={this.state.country} countries={this.state.countries} code={this.generateCode()} configuration={{ exterior: this.state.exterior, interior: this.state.interior, transom: this.state.transom }} />} />
            </Switch>);
    }
}

export default withTranslation()(XP44Container);


// WEBPACK FOOTER //
// ./src/XP44/XP44Container.js